module.exports = __webpack_public_path__ + "static/media/paper.8f4e95eb.svg";